module.exports = "img/button-text-inline-code-on.55b92c4.svg";